import React from 'react';
import './Home.css';

function Home() {
  const scrollToContato = () => {
    const contatoSection = document.getElementById('contato');
    if (contatoSection) {
      contatoSection.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section className="home-section" id="home">
      <div className="home-content">
        <div className="text-area">
          <h1>Transforme a gestão de energia com a Lampo</h1>
          <p>Automatize, otimize e avance no mercado de energia elétrica com a nossa tecnologia</p>
        </div>
        <div className="cta-card">
          <h2>Faça um teste customizado!</h2>
          <button onClick={scrollToContato}> <strong>Entre em contato </strong></button>
        </div>
      </div>
    </section>
  );
}

export default Home;
